<header class="header">
    <img src="../../../assets/images/menu/arrow-back.svg" alt="arrow-back" (click)="goToDashboard()" *ngIf="!isCross"/>
    <h2 class="title-section">{{section}}</h2>
    <div>
        <cross-svg *ngIf="isCross" (click)="back()"></cross-svg>
    </div>
</header>